<template>
	<div class="pages-work">
		<loading-state v-if="loading" />
		<div v-if="!loading && work" class="content-wrap">
			<template>
				<div class="detail-wrap">
					<div class="arrow-box">
						<img v-show="work.pre_project_key" class="left" src="../assets/comment/left-arrow.png" alt="#" @click="lastWork" />
						<img v-show="work.next_project_key" class="right" src="../assets/comment/right-arrow.png" alt="#" @click="nextWork" />
					</div>
					<div class="back">
						<img :src="
								require(`../assets/pc-change-images/backList-btn-${this.$i18n.locale}.png`)
							" alt="#" @click="goPageList" />
					</div>
					<div class="close" @click="goPageList()">X</div>
					<div class="title-img">
						<img :src="
								require(`../assets/pc-change-images/upload-logo-${this.$i18n.locale}.png`)
							" alt="#" />
					</div>
					<div class="work-wrapper">
						<div class="logo">
							<img src="../assets/comment/detail-logo.png" alt="#" />
						</div>
						<div class="image-wrapper">
							<img :src="work.url" alt />
						</div>
					</div>
					<div class="bottom">
						<div class="creator-info isPC">
							<div class="filed-label">
								<span class="left">{{ $t('work.workName') }}:</span>
								<span>{{ work.title }}</span>
							</div>
							<div class="filed-label">
								<span class="left">{{ $t('work.creator') }}:</span>
								<span>{{ work.creator_name }}</span>
							</div>
							<div class="filed-label">
								<span class="left">{{ $t('work.age') }}:</span>
								<span>{{ work.creator_age }}</span>
								<span class="left form">{{ $t('work.nationality') }}:</span>
								<span>{{ work.creator_from }}</span>
							</div>
						</div>
						<div class="creator-info isMobile">
							<div class="filed-label">
								<div>{{ $t('work.workName') }}:</div>
								<div>{{ work.title }}</div>
							</div>
							<div class="filed-label">
								<div>{{ $t('work.creator') }}:</div>
								<div>{{ work.creator_name }}</div>
							</div>
							<div class="filed-label">
								<el-row>
									<el-col :span="12">
										<div>{{ $t('work.age') }}:</div>
										<div>{{ work.creator_age }}</div>
									</el-col>
									<el-col :span="12">
										<div>{{ $t('work.nationality') }}:</div>
										<div>{{ work.creator_from }}</div>
									</el-col>
								</el-row>
							</div>
						</div>
						<div class="logo">
							<div class="qrCodeDiv-wrapper">
								<div id="qrCode" ref="qrCodeDiv"></div>
							</div>

							<div class="text">
								<img src="../assets/comment/small-icon.png" alt="#" />
							</div>
						</div>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import QRCode from 'qrcodejs2'
import LoadingState from '@/components/LoadingState'

export default {
	name: 'PagesWork',
	components: { LoadingState },
	props: {
		workId: {
			required: true
		}
	},
	data() {
		return {
			code2: null,
			work: null,
			loading: false
		}
	},
	computed: {
		pagePath() {
			return window.location.href
		}
	},
	methods: {
		goPageList() {
			this.$router.push({ name: 'PagesWorks' })
		},
		lastWork() {
			// this.startLoading()
			this.load(this.work.pre_project_key)
		},
		nextWork() {
			this.load(this.work.next_project_key)
		},
		bindQRCode() {
			this.code2 = 'https://russian.cgtn.com'
			new QRCode(this.$refs.qrCodeDiv, {
				text: this.code2,
				width: 60,
				height: 60,
				colorDark: '#000', //二维码颜色
				colorLight: '#ffffff', //二维码背景色
				correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
			})
		},
		startLoading() {
			if (this.loading) {
				return
			}
			this.loading = true
		},
		endLoading() {
			this.loading = false
		},
		load(workId) {
			// this.startLoading()

			this.$axios
				.get('/work_'+workId+'.json', {
          
				})
				.then((res) => {
					if (res.data.code === 200) {
						this.work = res.data.data
					} else {
						this.$message.error(res.data.msg || '加载失败，请刷新重试')
					}
				})
				.catch(() => {
					this.$message.error('加载失败，请刷新重试')
				})
				.finally(() => {
					// this.endLoading()
					if (!this.code2) {
						this.$nextTick(() => {
							this.bindQRCode()
						})
					}
				})
		}
	},
	mounted() {
		this.load(this.workId)
		if (localStorage.getItem('lang')) {
			this.$i18n.locale = localStorage.getItem('lang')
		}
	}
}
</script>

<style lang="stylus">
.pages-work {
  margin: 0 auto;

  .content-wrap {
    width: 100vw;
    min-height: 100vh;
    margin: 0 auto;
    padding: 40px 0 40px;
    background: url('../assets/comment/detail-bg.png') no-repeat;
    background-size: cover;
    box-sizing: border-box;

    .detail-wrap {
      position: relative;
      box-sizing: border-box;
      width: 70%;
      margin: 0 auto;
      background-color: rgba(171, 173, 226, 0.6);
      border-radius: 20px;
      padding: 20px 100px;

      .close {
        display: none;
      }

      .arrow-box {
        box-sizing: border-box;
        width: 100%;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translate(0, -50%);
        padding: 0 20px;
        overflow: hidden;

        img {
          width: 30px;
          height: 70px;
          cursor: pointer;
        }

        .left {
          float: left;
        }

        .right {
          float: right;
        }
      }

      .back {
        position: absolute;
        top: 40px;
        right: 30px;

        img {
          width: 50px;
          height: 35px;
          cursor: pointer;
        }
      }

      .title-img {
        width: 260px;
        height: 80px;
        margin-bottom: 8px;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .work-wrapper {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        height: 450px;
        background-color: #fff;
        padding: 10px 10px;

        .logo {
          position: absolute;
          top: -30px;
          right: -24px;

          img {
            width: 130px;
            height: 80px;
          }
        }

        .image-wrapper {
          margin: 0 auto;
          width: 100%;
          height: 100%;

          img {
            margin: 0 auto;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }

      .bottom {
        .isMobile {
          display: none;
        }

        .creator-info {
          float: left;
          font-weight: 500;
          line-height: 24px;
          color: #fff;
          padding: 10px 20px;

          .filed-label {
            color: #fff;
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 8px;
            width: 500px;
            word-break: break-all;

            .left {
              margin-right: 10px;

              &.form {
                margin-left: 60px;
              }
            }
          }
        }

        .logo {
          float: right;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 10px;
          margin-right: -30px;

          .qrCodeDiv-wrapper {
            width: 72px;
            height: 72px;
            padding: 6px;
            border-radius: 10px;
            background-color: #fff;
            box-sizing: border-box;

            #qrCode {
              width: 60px;
              height: 60px;
              margin-bottom: 5px;
              border-radius: 10px;
              background-color: #fff;
            }
          }

          .text {
            margin-top: 8px;

            img {
              width: 110px;
              height: 14px;
            }
          }
        }
      }

      .bottom:after {
        visibility: hidden;
        display: block;
        font-size: 0;
        content: ' ';
        clear: both;
        height: 0;
      }
    }
  }
}

/* 手机 */
@media screen and (max-width: 600px) {
  .content-wrap {
    background: url('../assets/mobileImagesBg/m-detail-bg.png') no-repeat;
    background-size: cover;

    .detail-wrap {
      width: 90% !important;
      padding: 12px !important;
      min-height: 90vh;

      .close {
        display: block !important;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #fff;
        background-color: #eb6877;
        position: absolute;
        right: 5px;
        top: 5px;
        font-size: 26px;
        font-weight: 700;
        border-radius: 10px;
      }

      .title-img {
        width: 100% !important;
        margin-bottom: 20px !important;
      }

      .back {
        display: none !important;
      }

      .arrow-box {
        top: 55% !important;

        .right, .left {
          height: 50px !important;
        }
      }

      .work-wrapper {
        height: 195px !important;

        .logo {
          top: -17px !important;
          right: -16px !important;

          img {
            width: 80px !important;
            height: 50px !important;
          }
        }
      }

      .bottom {
        display: flex;
        flex-direction: column;
        justify-items: center;
        text-align: center;
        margin-top: 14px;

        .isPC {
          display: none !important;
        }

        .isMobile {
          display: block !important;
        }

        .creator-info {
          .filed-label {
            width: 90% !important;
            margin: 0 auto !important;
          }
        }

        .creator-info {
          margin-bottom: 18px;
        }
      }

      .logo {
        margin-right: 0 !important;
      }
    }
  }
}

/* 平板 */
@media screen and (min-width: 600px) and (max-width: 960px) {
  .image-wrapper {
    height: 250px !important;
  }

  .logo-image {
    display: none !important;
  }

  .more-work {
    padding: 12px !important;
  }
}
</style>
